import { environmentDev } from '@nirby/environment/dev';

export const environment = {
    ...environmentDev(),
};

// Available log tags: 'ROUTE-PARAMS', 'DB', 'BLOCK-EDITOR', 'ACTION-INPUT', 'MIGRATION', 'LOGGER'
